import * as yup from 'yup';

// Copied from CompanyDetailsDE.schema.ts — keep in sync if the desktop rule changes.
const monthRegex = /^(?:0?[1-9]|1[012])$/;

// No lower bound (old companies are valid); the upper bound stops an
// out-of-range year (e.g. 9999) reaching the backend as an invalid RFC3339 date.
const isNotFutureYear = (value?: string) => {
  const year = Number(value);
  if (!year) return true; // required/min already report the empty case as "benötigt"
  return year <= new Date().getFullYear();
};

export const foundingDateSchema = yup.object().shape({
  startDateMonth: yup
    .string()
    .required('benötigt')
    .matches(monthRegex, 'ungültige Eingabe'),
  startDateYear: yup
    .string()
    .required('benötigt')
    .min(4, 'benötigt')
    .max(4, 'ungültige Eingabe')
    .test('not-future', 'ungültige Eingabe', isNotFutureYear),
});
